import { render, staticRenderFns } from "./u-combobox-outlined-rounded.vue?vue&type=template&id=10420b34&scoped=true&"
import script from "./u-combobox-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-combobox-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10420b34",
  null
  
)

export default component.exports